import { useEffect, useState } from 'react';
import { DataHubStore } from 'src/core/services/datahub';
export function useInitDataHubStore({ user, membershipId, membershipSlug }) {
    const [isInitingDataHubStore, setIsInitingDataHubStore] = useState(true);
    useEffect(function effectInitDataHubStore() {
        if (user) {
            DataHubStore.initData({
                membershipId,
                membershipSlug,
                ucode: user.ucode,
                sessionId: user.sessionId,
                marketplaceId: Number(user.id)
            });
            setIsInitingDataHubStore(false);
        }
    }, [membershipSlug, user, membershipId]);
    return { isInitingDataHubStore };
}
export default useInitDataHubStore;
